/**
 * Job edit stays mounted across contact refetches, but must not render
 * EditJobForm until the loaded job matches the route. Otherwise a job-id
 * change reuses react-hook-form state (and tasks) from the previous job.
 */
export function isJobEditDataReady<TForm, TJob extends { id: string }>(
  form: TForm | null | undefined,
  job: TJob | null | undefined,
  jobId: string
): form is NonNullable<TForm> {
  return Boolean(form && job && String(job.id) === String(jobId));
}
